import React from 'react'
import './DetailsDummy.css'


const DetailsDummy = () => {
    return (
        <div className='mainDivDetails'>
            <div className='mainDiv2'>
                <div className='DetailPage'>
                    <p className='imgDiv'></p>
                    <div className='otherImg'>
                        <div className='box1'></div>
                        <div className='box1' style={{ marginLeft: '15px' }}></div>
                        <div className='box1' style={{ marginLeft: '15px' }}></div>
                    </div>
                    <div className='ButtonStyle'>
                        <button className='pi'></button>
                        <button className='pi'></button>

                    </div>
                </div>


            </div>
            <div className='Detail'>

                <div className='k1'></div>
                <div className='k1'></div>
                <div className='k2'></div>
                <div className='k3'></div>
                <div className='k4'> </div>
                <div className='k5'></div>
                <div className='k6'></div>
                <div className='k6'></div>
                <div className='k6'></div>
                <div className='k6'></div>
                <div className='k6'> </div>
            </div>


        </div>
    )
}

export default DetailsDummy
